module.exports = __webpack_public_path__ + "static/media/Cross bite6.8c860c31.png";